import { getBaseFeature } from '@/assets/style/variable'

export const pageCssVars = {
  methods: {
    cssVars() {
      return { ...getBaseFeature() }
    },
  },
}
